import React, { useImperativeHandle, useRef, useState } from "react";
import clsx from "clsx";
import { v4 as uuid } from "uuid";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { Icons, Box, Button, Form, IconButton, ListItem, TextField } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { FieldRow } from "@icoach/documents/components/Layout";
import { useMemberProfileApi } from "@apis/useMemberProfileApi";
import { isEmpty, isFunction, refIsRequiredError } from "@util/utils";
import { MEMBER_NOTE_TYPE } from "@icoach/constants";

export const NotesItemDialogContent = React.forwardRef((props, ref) => {
	const { title, sourceData } = props;
	const [fields, setFields] = useState(() => {
		if (Array.isArray(sourceData)) {
			return sourceData.map(text => ({
				id: uuid(),
				value: text,
			}));
		}
		return [];
	});
	const fieldsRef = useRef([]);

	const handleAddNoteItem = () => {
		if (fields.length >= 5) return null;
		setFields(old => {
			let arr = [...old];
			arr.push({
				id: uuid(),
				value: "",
			});
			return arr;
		});
	};
	const handleDeleteNoteItem = id => {
		setFields(old => {
			return old.filter(item => item.id !== id);
		});
	};

	useImperativeHandle(
		ref,
		() => ({
			getResult: () => {
				return fieldsRef.current.filter(item => item).map(item => item.getResult());
			},
			isError: () => refIsRequiredError(fieldsRef.current),
		}),
		// eslint-disable-next-line
		[]
	);
	return (
		<DialogContent>
			<Box className={clsx("text-right mb-4", { hide: fields.length >= 5 })}>
				<Button startIcon={<Icons.Plus />} onClick={handleAddNoteItem}>
					新增事項
				</Button>
			</Box>
			<Grid container spacing={2}>
				{!isEmpty(fields) &&
					fields.map(({ value, id }, i) => (
						<FieldRow key={id} items={[3, 9]} label={`${title}-${i + 1}`}>
							<ListItem className="p-0" required>
								<TextField ref={el => (fieldsRef.current[i] = el)} InputProps={{ placeholder: "請輸入" }} defaultValue={value} fullWidth />
								<IconButton onClick={() => handleDeleteNoteItem(id)}>
									<Icons.ErrorCircle />
								</IconButton>
							</ListItem>
						</FieldRow>
					))}
			</Grid>
		</DialogContent>
	);
});

const AgreedNotesDialog = React.forwardRef((props, ref) => {
	const { className, open, sourceData, onClose, refresh } = props;
	if (!open) return null;
	const { memberID, agreedNotes } = sourceData || {};
	const { postMemberProfileNotesApi } = useMemberProfileApi();
	const contentRef = useRef(null);

	const doMemberProfileNotesApi = async (memberID, params) => {
		let resp = await postMemberProfileNotesApi(memberID, params);
		if (resp) {
			const { noteItems } = resp;
			isFunction(refresh) && refresh(noteItems);
			isFunction(onClose) && onClose();
		}
	};

	const handleSubmit = () => {
		let isError = contentRef.current && contentRef.current.isError();
		if (!isError) {
			let params = {
				noteType: MEMBER_NOTE_TYPE.AGREED,
				noteItems: contentRef.current && contentRef.current.getResult(),
			};
			doMemberProfileNotesApi(memberID, params);
		}
	};

	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-65rem", component: Form }} onSubmit={handleSubmit} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>約定事項</GradientColorHeader>
			<NotesItemDialogContent ref={contentRef} sourceData={agreedNotes} title={"約定事項"} />
			<DialogActions>
				<Button type={"submit"} variant="contained">
					確認送出
				</Button>
			</DialogActions>
		</Dialog>
	);
});

export default AgreedNotesDialog;
